import { AxiosResponse, AxiosError } from 'axios';

import {
    MyTimesheetEntryUuid,
    MyTimesheetEntry,
    MyTimesheetEntries,
    MyTimesheetEntriesLoadRequestedAction,
    MyTimesheetEntriesLoadSucceededAction,
    MyTimesheetEntriesLoadFailedAction,
    MyTimesheetEntriesLoadCanceledAction,
    MyTimesheetEntriesSaveSucceededAction,
    MyTimesheetEntriesSaveRequestedAction,
    MyTimesheetEntriesSaveFailedAction,
    MyTimesheetEntriesAddAction,
    MyTimesheetEntriesUpdateAction,
    MyTimesheetEntriesRemoveAction,
    MyTimesheetEntriesSetReadOnlyAction,
    MyTimesheetEntriesSetAction,
    MyTimesheetEntriesMergeAction,
    MyTimesheetEntriesDeleteAction
} from './types';
import {
    MY_TIMESHEET_ENTRIES_LOAD_REQUESTED,
    MY_TIMESHEET_ENTRIES_LOAD_SUCCEEDED,
    MY_TIMESHEET_ENTRIES_LOAD_FAILED,
    MY_TIMESHEET_ENTRIES_LOAD_CANCELED,
    MY_TIMESHEET_ENTRIES_SAVE_REQUESTED,
    MY_TIMESHEET_ENTRIES_SAVE_SUCCEEDED,
    MY_TIMESHEET_ENTRIES_SAVE_FAILED,
    MY_TIMESHEET_ENTRY_ADD,
    MY_TIMESHEET_ENTRY_UPDATE,
    MY_TIMESHEET_ENTRY_REMOVE,
    MY_TIMESHEET_ENTRIES_SET_READ_ONLY,
    MY_TIMESHEET_ENTRIES_SET,
    MY_TIMESHEET_ENTRIES_MERGE,
    MY_TIMESHEET_ENTRIES_DELETE
} from './constants';

/**
 * Intended to be called from a component.
 */
export function requestMyTimesheetEntriesLoad(): MyTimesheetEntriesLoadRequestedAction {
    return {
        type: MY_TIMESHEET_ENTRIES_LOAD_REQUESTED
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param response
 */
export function succeededLoadMyTimesheetEntries(
    response: AxiosResponse
): MyTimesheetEntriesLoadSucceededAction {
    return {
        type: MY_TIMESHEET_ENTRIES_LOAD_SUCCEEDED,
        payload: response
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param error
 */
export function failedLoadMyTimesheetEntries(
    error: AxiosError
): MyTimesheetEntriesLoadFailedAction {
    return {
        type: MY_TIMESHEET_ENTRIES_LOAD_FAILED,
        payload: error,
        error: true
    };
}

/**
 * Intended to be called from a component.
 */
export function myTimesheetEntriesLoadCanceled(): MyTimesheetEntriesLoadCanceledAction {
    return {
        type: MY_TIMESHEET_ENTRIES_LOAD_CANCELED
    };
}

/**
 * Intended to be called from either a redux-sagas or component.
 */
export function requestSaveMyTimesheetEntries(): MyTimesheetEntriesSaveRequestedAction {
    return {
        type: MY_TIMESHEET_ENTRIES_SAVE_REQUESTED
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param response
 */
export function succeededSaveMyTimesheetEntries(
    response: AxiosResponse
): MyTimesheetEntriesSaveSucceededAction {
    return {
        type: MY_TIMESHEET_ENTRIES_SAVE_SUCCEEDED,
        payload: response
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param error
 */
export function failedSaveMyTimesheetEntries(
    error: AxiosError
): MyTimesheetEntriesSaveFailedAction {
    return {
        type: MY_TIMESHEET_ENTRIES_SAVE_FAILED,
        payload: error,
        error: true
    };
}

/**
 * Intended to be called from a component.
 * @param entry
 */
export function addMyTimesheetEntry(
    entry: MyTimesheetEntry
): MyTimesheetEntriesAddAction {
    return {
        type: MY_TIMESHEET_ENTRY_ADD,
        payload: entry
    };
}

/**
 * Intended to be called from a component.
 * @param entry
 */
export function updateMyTimesheetEntry(
    entry: MyTimesheetEntry
): MyTimesheetEntriesUpdateAction {
    return {
        type: MY_TIMESHEET_ENTRY_UPDATE,
        payload: entry
    };
}

/**
 * Intended to be called from a component.
 * @param myTimesheetEntryUuid
 */
export function removeMyTimesheetEntry(
    myTimesheetEntryUuid: MyTimesheetEntryUuid
): MyTimesheetEntriesRemoveAction {
    return {
        type: MY_TIMESHEET_ENTRY_REMOVE,
        payload: myTimesheetEntryUuid
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param entries
 */
export function setReadOnlyMyTimesheetEntries(
    entries: MyTimesheetEntries
): MyTimesheetEntriesSetReadOnlyAction {
    return {
        type: MY_TIMESHEET_ENTRIES_SET_READ_ONLY,
        payload: entries
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param entries
 */
export function setMyTimesheetEntries(
    entries: MyTimesheetEntries
): MyTimesheetEntriesSetAction {
    return {
        type: MY_TIMESHEET_ENTRIES_SET,
        payload: entries
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param myTimesheetEntries
 */
export function mergeSetMyTimesheetEntries(
    myTimesheetEntries: MyTimesheetEntries
): MyTimesheetEntriesMergeAction {
    return {
        type: MY_TIMESHEET_ENTRIES_MERGE,
        payload: myTimesheetEntries
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param myTimesheetEntryUuid
 */
export function deleteMyTimesheetEntries(
    myTimesheetEntryUuids: MyTimesheetEntryUuid | MyTimesheetEntryUuid[]
): MyTimesheetEntriesDeleteAction {
    return {
        type: MY_TIMESHEET_ENTRIES_DELETE,
        payload: myTimesheetEntryUuids
    };
}
